import React from "react";
import ReactDOM from "react-dom/client";
import Map from "../components/staticMap/HeavyMachineMap";

export default () => {
  const element = document.getElementById("resource-static-map-root");
  if (!element) return;
  if (element.clientWidth === 0) return; // MEMO: 当該タブが非表示の場合は0

  if (!element.dataset.gcp || !element.dataset.resource || !element.dataset.sites) return;

  ReactDOM.createRoot(element).render(
    <Map
      gcp={JSON.parse(element.dataset.gcp)}
      resource={JSON.parse(element.dataset.resource)}
      sites={JSON.parse(element.dataset.sites)}
      width={element.clientWidth}
    />,
  );
};
